





































































import CategorySpecification from '~/components/car/classifieds/view/partials/Specifications/CategorySpecification.vue'
import ForMakeModelSpecification from '~/components/car/classifieds/view/partials/Specifications/ForMakeModelSpecification.vue'
import FinanceSpecification from '~/components/car/classifieds/view/partials/Specifications/FinanceSpecification.vue'
import PriceSpecification from '~/components/car/classifieds/view/partials/Specifications/PriceSpecification.vue'
import FuelConsumptionSpecification from '~/components/car/classifieds/view/partials/Specifications/FuelConsumptionSpecification.vue'
import LinkSpecification from '~/components/car/classifieds/view/partials/Specifications/LinkSpecification.vue'
import RegistrationSpecification from '~/components/car/classifieds/view/partials/Specifications/RegistrationSpecification.vue'
import OfferTypeSpecification from '~/components/car/classifieds/view/partials/Specifications/OfferTypeSpecification.vue'
import ParkedSpecification from '~/components/car/classifieds/view/partials/Specifications/ParkedSpecification.vue'
import ExtraTelephoneSpecification from '~/components/car/classifieds/view/partials/Specifications/custom/ExtraTelephoneSpecification.vue'
import DefaultSpecificationValue from '~/components/car/classifieds/view/partials/Specifications/DefaultSpecificationValue.vue'
import { Specification } from '~/models/classified/types'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    DefaultSpecificationValue,
    ExtraTelephoneSpecification,
    ParkedSpecification,
    OfferTypeSpecification,
    RegistrationSpecification,
    LinkSpecification,
    FuelConsumptionSpecification,
    PriceSpecification,
    FinanceSpecification,
    ForMakeModelSpecification,
    CategorySpecification
  },
  props: {
    specification: {
      type: Object as PropType<Specification>,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    getExtraInfo(specification) {
      if (specification.extra_info) {
        return specification.extra_info
      }

      if (specification.name === 'registration') {
        return this.$t(
          'please make sure that the listed registration is the date of the first declaration, e.g. if it was registered abroad then that is the valid date.'
        )
      }
      return null
    }
  }
})
